<div *ngIf="content.title">
  <h3 class="skymiles-benefits-section-header">
    <span>{{ content.title }}</span>
  </h3>

  <div
    *ngIf="displayManagerService.index$ | ngrxPush as index"
    [className]="
      'skymiles-benefits-section skymiles-benefits-section__last-tier--' +
      (+index === 4 || content.stacks.length === 1)
    "
  >
    <div
      [className]="
        'skymiles-benefits-section__container skymiles-benefits-section__container--' +
        content.stacks[+index].tier
      "
    >
      <div class="skymiles-benefits-section__container__details" #swipeZone>
        <div class="skymiles-benefits-section__container__details__member">
          <span
            class="skymiles-benefits-section__container__details__member__title"
            [innerHtml]="content.stacks[+index].title"
          ></span>
        </div>
        <idp-goodies [content]="content" [index]="+index"></idp-goodies>
      </div>
      <div
        class="skymiles-benefits-section__container__seperator"
        *ngIf="content.stacks.length !== 1"
      ></div>
      <idp-paginator
        *ngIf="content.stacks.length !== 1"
        [paginator]="{
          index: +index,
          actions: content.actions,
          ariaLabels: { title: getAriaLabels(content.stacks) },
          count: content.stacks.length
        }"
      ></idp-paginator>
    </div>
    <idp-peak-bar
      class="skymiles-benefits-section__peak-bar"
      *ngIf="+index !== 4 && content.stacks.length !== 1"
      [content]="content"
      [index]="+index"
    ></idp-peak-bar>
  </div>
</div>
